(function () {
  'use strict';

  var heroSelector = '[data-hp-hero]';
  var videoSelector = '.hp-hero__video';

  function getVideos(root) {
    var videos = [];

    if (!root) {
      root = document;
    }

    if (root.nodeType === 1 && root.matches(videoSelector)) {
      videos.push(root);
    }

    if (root.querySelectorAll) {
      videos = videos.concat(Array.from(root.querySelectorAll(videoSelector)));
    }

    return videos;
  }

  function play(video) {
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /*
         * Muted inline video normally satisfies autoplay policies. If the
         * browser still delays playback, retry as soon as it can render.
         */
        video.addEventListener('canplay', function retryAutoplay() {
          var retryPromise = video.play();

          if (retryPromise && typeof retryPromise.catch === 'function') {
            retryPromise.catch(function () {});
          }
        }, { once: true });
      });
    }
  }

  function init(root) {
    getVideos(root).forEach(function (video) {
      play(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches(heroSelector) || event.target.querySelector(heroSelector)) {
      init(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.matches(heroSelector) || event.target.querySelector(heroSelector)) {
      init(event.target);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      init(document);
    }
  });

  window.addEventListener('pageshow', function () {
    init(document);
  });
})();
